import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { deleteRom, fetchRomParticipants, fetchRoms } from "../api/romsApi";

const QUERY_KEY = ["roms"];

export const useRomsQuery = () => {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: fetchRoms,
  });
};

export const useRomParticipantsQuery = (romId: string | null) => {
  return useQuery({
    queryKey: ["rom-participants", romId],
    queryFn: () => fetchRomParticipants(romId!),
    enabled: !!romId,
  });
};

export const useDeleteRom = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => deleteRom(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEY });
    },
  });
};
